export default __webpack_public_path__ + "static/button-action-dont-light-a1adfd92b79d73839efced4a9fb1fd66e51f2ce0e46d70d5bc5be21eed1f7a5b.png";